import { render, staticRenderFns } from "./ParkingStopsSidebar.vue?vue&type=template&id=0980f4e2&scoped=true"
import script from "./ParkingStopsSidebar.vue?vue&type=script&lang=js"
export * from "./ParkingStopsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ParkingStopsSidebar.vue?vue&type=style&index=0&id=0980f4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980f4e2",
  null
  
)

export default component.exports